<template>
  <layout-vertical>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>
    <!-- <div slot="footer">
      <p class="mb-0">
        &copy; Some Company {{ new Date().getFullYear() }}
      </p>
    </div> -->
    <!-- <div
      slot="navbar"
      class="px-1"
    >
      <p class="mb-0">I am in navbar, Everything else is removed</p>
    </div> -->

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
    <!-- <my-customizer
      v-if="showCustomizer"
      slot="customizer"
      :listTutoriales="listTutoriales"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import MyCustomizer from '@core/layouts/components/app-customizer/MyCustomizer.vue'
import { $themeConfig } from '@themeConfig'
// import { ref, onMounted } from '@vue/composition-api'
import Navbar from '../components/Navbar.vue'
// import { URL, USER } from '../../utils/variables'
// import apiCall from '../../utils/apiCall'

export default {
  components: {
    // AppCustomizer,
    // MyCustomizer,
    LayoutVertical,
    Navbar,
  },
  setup() {
    // const { getApi } = apiCall()
    // const listTutoriales = ref([])

    // async function getJugadores() {
    //   // listJugadores.value = []
    //   const path = `ApiConfiguration/getTutoriales/${USER().rol}`
    //   const data = await getApi(URL, path)
    //   // console.log(data)
    //   // console.log(USER().rol)
    //   if (data.flag === 's') {
    //     listTutoriales.value = data.data
    //   } else {
    //     listTutoriales.value = []
    //   }
    // }

    return {
      showCustomizer: $themeConfig.layout.customizer,
      // listTutoriales,
    }
  },
  // data() {
  //   console.log('en my custom')

  // },
}
</script>
